function getApiUrl() {
  return import.meta.env.VITE_DEV_API_URL ?? window.location.origin
}

export { getApiUrl }
